<template>
    <div class="fleet-edit__view">

        <div class="form">
            <fleet-form :handler="editFleet" :form="form" :back-button="false">
                <v-layout row slot="info">
                    <div class="info-block">
                        {{ $t('editFleet.info') }}
                    </div>
                </v-layout>
            </fleet-form>
        </div>

        <vehicles-list v-if="hasAllRoles(['VehicleView'])" :uuid="uuid"></vehicles-list>
        <devices-table v-if="unallocatedDevices && unallocatedDevices > 0 && hasAllRoles(['DeviceView'])" class="devices-table" :fleet="{ id: uuid, name: form.name }" unassigned></devices-table>
        <v-layout row class="buttons">
            <v-flex xs6>
                <sp-button @click.native="goBack" :text="$t('formFleet.buttons.goBack')" small-icon icon="go-back" sp-class="go-back"></sp-button>
            </v-flex>
        </v-layout>
        <sp-loader v-if="isLoading"></sp-loader>
    </div>
</template>

<script>
import FleetForm from '@/views/Fleets/components/FleetForm'
import FleetApi from '@/api/FleetApi'
import FleetSettingsApi from '@/api/FleetSettingsApi'
import VehiclesList from '@/views/Vehicles/VehiclesList'
import DevicesTable from '@/views/Devices/components/DevicesTable'
import SpButton from '@/components/forms/Button'
import toast from '@/plugins/izitoast'
import router from '@/router/routes'
import SpLoader from '@/components/atoms/Loader'

const fleetApi = new FleetApi()

export default {
    name: 'FleetEdit',
    components: {
        FleetForm,
        VehiclesList,
        DevicesTable,
        SpButton,
        SpLoader
    },
    created () {
        this.uuid = this.$route.params.fleetUuid
        this.getFleetData(this.uuid)
        this.fleetSettingsApi = new FleetSettingsApi()
    },
    data () {
        return {
            uuid: null,
            settingsModal: false,
            isLoading: false,
            form: {
                id: '',
                name: ''
            },
            notificationSettingsModal: false,
            unallocatedDevices: null
        }
    },
    methods: {
        async getFleetData (uuid) {
            this.isLoading = true
            const response = await fleetApi.getFleet(uuid)

            this.form.id = response.payload.id
            this.form.name = response.payload.name
            this.unallocatedDevices = response.payload.unallocatedDevices
            this.isLoading = false
        },
        async editFleet (form) {
            const response = await fleetApi.editFleet(this.uuid, form.name)

            if (!response.isSuccess) {
                return
            }

            toast.success(this.$t('editFleet.successMassage'))
        },
        goBack () {
            router.back()
        },
        openModal (value) {
            if ('eventAlertLevelsSettings' === value) {
                this.eventAlertLevelsSettingsModal = !this.eventAlertLevelsSettingsModal
            }
        }
    }
}
</script>

<style scoped lang="scss">
.fleet-edit__view {
    width: 100%;
}

#spillard-theme {
    .v-btn:not(:last-child) {
        margin: 0 10px 0 0;
    }
}
.devices-table {
    margin-top: 40px;
}
</style>
